import doesActiveExperiencesInclude from "./doesActiveExperiencesInclude";
import type { MailboxInfo } from "owa-client-types";
import { trace } from "owa-trace";
import { logUsage } from "owa-analytics";

/**
 * Checks to see if the user has Copilot License
 * @returns true if the user has Copilot License
 */
export function isCopilotBusinessChat(mailboxInfo?: MailboxInfo): boolean {
    const hasCopilotBusinessChatLicense = doesActiveExperiencesInclude("CopilotBusinessChat", mailboxInfo);
    /* eslint-disable-next-line owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
     *	> Invalid Outlook telemetry EventName "hasCopilotBusinessChatLicense": must start with a capital letter (A–Z). */
    logUsage("hasCopilotBusinessChatLicense", mailboxInfo, { hasCopilotBusinessChatLicense });
    trace.info("License Check Feature enabled and HasCopilotBusinessChatLicense: " +
        hasCopilotBusinessChatLicense);
    return hasCopilotBusinessChatLicense;
}
